import "core-js/modules/es.array.includes.js";
import Layout from "./components/Layout.vue";
import config from "./config";
import { mapMutations } from "vuex";
export default {
  name: "App",
  components: {
    Layout
  },
  computed: {
    layout() {
      return this.$route.path !== "/" && this.$route.path && !config.noLayoutPages.includes(this.$route.path);
    }
  },
  created() {
    // 初始化移动端检测
    this.initIsMobile();
    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    ...mapMutations(["setIsMobile"]),
    initIsMobile() {
      const isMobile = document.body.clientWidth < 600;
      this.setIsMobile(isMobile);
    },
    handleResize() {
      const isMobile = document.body.clientWidth < 600;
      this.setIsMobile(isMobile);
    }
  }
};